import Roles from '@/auth/roles';
import i18n from '@/lang' // Internationalization
import historyFullStore from './position-history/position-history-full/position-history-full-store';
import historySingleStore from './position-history/position-history-single/position-history-single-store';
import positionModel from './position-model';
import positionPager from './position-pager';
import service from './position-service';

export default {
  namespaced: true,

  modules: {
    historyFull: historyFullStore,
    historySingle: historySingleStore
  },

  state: {
    loading: false,
    list: [],
    pager: positionPager.build(),
    model: positionModel.default(),
  },

  getters: {
    loading: state => state.loading,
    list: state => state.list,
    pager: (state) => state.pager,
    model: state => state.model,
    hasRoleToUpdate: (
      state,
      getters,
      rootState,
      rootGetters
    ) => {
      const roles = Roles.values;
      return rootGetters['auth/hasRole']([
        roles.owner.id,
        roles.entityEditor.id,
        roles.positionEditor.id
      ]);
    },
    hasRoleToCreate: (
      state,
      getters,
      rootState,
      rootGetters
    ) => {
      const roles = Roles.values;
      return rootGetters['auth/hasRole']([
        roles.owner.id,
        roles.entityEditor.id,
        roles.positionEditor.id
      ]);
    },
    hasRoleToRead: (
      state,
      getters,
      rootState,
      rootGetters
    ) => {
      const roles = Roles.values;
      return rootGetters['auth/hasRole']([
        roles.owner.id,
        roles.activityViewer.id,
        roles.entityViewer.id,
        roles.entityEditor.id,
        roles.positionViewer.id,
        roles.positionEditor.id
      ]);
    },
    hasRoleToReadLogs: (
      state,
      getters,
      rootState,
      rootGetters
    ) => {
      const roles = Roles.values;
      return rootGetters['auth/hasRole']([
        roles.owner.id,
        roles.activityViewer.id
      ]);
    },
    hasRoleToDelete: (
      state,
      getters,
      rootState,
      rootGetters
    ) => {
      const roles = Roles.values;
      return rootGetters['auth/hasRole']([
        roles.owner.id,
        roles.entityEditor.id,
        roles.positionEditor.id
      ]);
    }
  },

  mutations: {
    LOADING(state, payload) {
      state.loading = !!payload;
    },

    LIST(state, payload) {
      state.list = payload || [];
    },

    MODEL(state, payload) {
      state.model = payload || positionModel.default();
    },

    CLEAR(state) {
      state.loading = false;
      state.list = [];
      state.pager = positionPager.build();
      state.model = positionModel.default();
    },
  },

  actions: {
    detail({ commit, dispatch }, id) {
      commit('LOADING', true);

      return service.find(id).then((model) => {
        if (!model || !model.id) {
          return Promise.reject(new Error('Not found'));
        }

        commit('MODEL', model);
        commit('LOADING', false);
        return Promise.resolve();
      }).catch((error) => {
        commit('LOADING', false);
        dispatch('shared/error', error, { root: true });
        return Promise.reject(error);
      });
    },

    new({ commit }) {
      commit('MODEL', null);
    },

    edit({ commit, dispatch }, id) {
      commit('LOADING', true);

      return service.find(id).then((model) => {
        if (!model || !model.id) {
          return Promise.reject(new Error('Not found'));
        }

        commit('MODEL', model);
        commit('LOADING', false);
        return Promise.resolve();
      }).catch((error) => {
        commit('LOADING', false);
        dispatch('shared/error', error, { root: true });
        return Promise.reject(error);
      });
    },

    save({ getters, commit, rootGetters, dispatch }) {
      commit('LOADING', true);

      return service
        .save(getters.model, rootGetters['auth/user'])
        .then(() => {
          dispatch(
            'shared/success',
            `${i18n.t('entities.position.singular')} ${i18n.t('notification.savedSuccessfully')}`,
            { root: true }
          );

          commit('LOADING', false);
        }).catch((error) => {
          commit('LOADING', false);
          dispatch('shared/error', error, { root: true });
          return Promise.reject(error);
        });
    },

    destroy({ commit, dispatch, rootGetters }, id) {
      commit('LOADING', true);

      return service
        .destroy(id, rootGetters['auth/user'])
        .then(() => {
          dispatch(
            'shared/success',
            `${i18n.t('entities.position.singular')} ${i18n.t('notification.deletedSuccessfully')}`,
            { root: true }
          );
        })
        .then(() => dispatch('list'))
        .catch((error) => {
          commit('LOADING', false);
          dispatch('shared/error', error, { root: true });
          return Promise.reject(error);
        });
    },

    list({ commit, dispatch }) {
      commit('LIST', []);
      commit('LOADING', true);

      return service
        .list()
        .then((list) => {
          commit('LIST', list);
          commit('LOADING', false);
        })
        .catch((error) => {
          commit('LOADING', false);
          dispatch('shared/error', error, { root: true });
          return Promise.reject(error);
        });
    },

    clear({ commit }) {
      commit('CLEAR');
    },
  },
};



// WEBPACK FOOTER //
// ./src/entities/position/position-store.js